function isValidHttpUrl(string) {
    var res = string.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
    return (res !== null)
}

document.addEventListener("DOMContentLoaded", (e) => {
    let toggles = document.querySelectorAll(".js-checkbox-status");

    toggles.forEach(toggle => {
        toggle.addEventListener('click', function() {
            const checkbox = this.querySelector('input[type="checkbox"]');
            const info = this.closest('.notification-modal').querySelector('.modal-form');
            const span = this.querySelector('span');

            checkbox.checked = !checkbox.checked;

            if(checkbox.checked) {
                this.classList.remove('bg-gray-400');
                this.classList.add('bg-blue-600');
                span.classList.remove('translate-x-0');
                span.classList.add('translate-x-5');
                info.classList.remove('hidden');
            } else {
                this.classList.remove('bg-blue-600');
                this.classList.add('bg-gray-400');
                span.classList.remove('translate-x-5');
                span.classList.add('translate-x-0');
                info.classList.add('hidden');
            }

            this.setAttribute('aria-checked', checkbox.checked);
        });
    });

    let webhookUrl = document.getElementById('webhook_url');

    if(webhookUrl){
        webhookUrl.addEventListener('keyup', function() {
            if(!isValidHttpUrl(this.value)){
                this.classList.remove('bg-green-100');
                this.classList.add('bg-red-200');
            } else {
                this.classList.remove('bg-red-200');
                this.classList.add('bg-green-100');
            }
        })
    }
});